import styled, { css } from 'styled-components';
import media from 'src/styles/Media.styled';

export const FullyInvoicedContainer = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    ${media.mobileDevice`
        border: 1px solid #DEDEDE;
        border-radius: 10px;
        box-shadow: 0px 0px 2px #00000029;
    `}
`;

export const InvoicedContainer = styled.div`
    display: flex;
    flex-direction: column;
    background-color: #ffffff;
    opacity: 1;
    width: 100%;
    margin-bottom: ${({ isReplenish }) => (isReplenish ? '10px' : '0px')};
    border: 1px solid #e8e8e8;
    border-radius: 6px;

    ${media.mobileDevice`
        border-bottom: 1px solid #DEDEDE;
        border-radius: 0px;
        box-shadow: 0px 0px 2px #00000029;
    `}
`;

export const InvoiceDetailsContainer = styled.div`
    display: flex;
    padding: 0.7rem 0.4rem;
    border-bottom: 1px solid #e8e8e8;
    justify-content: space-between;
    align-items: flex-start;
    width: 100%;
    border-radius: 7px;
    background: ${({ setbackground }) =>
        setbackground ? '#F9F9F9' : '#FFFFFF'};
    &:last-child {
        border-bottom: none;
    }

    ${media.mobileDevice`
        flex-direction: column;
        padding: 0.7rem 0.3rem;
        position: relative;
    `}
`;

export const InvoiceOrderDetails = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    width: 65%;
    ${media.mediumDevice`
        width: 60%;
    `}
    ${media.smalDevice`
        width: 55%;
    `}
    ${media.mobileDevice`
        width: 100%;
        margin-bottom: 5px;
    `}
`;

export const InvoiceOrderNoPriceContainer = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    width: 35%;

    ${media.mediumDevice`
        width: 40%;
    `}

    ${media.smalDevice`
        width: 45%;
    `}

    ${media.mobileDevice`
        width: 100%;
    `}
`;

export const InvoiceDataContainer = styled.div`
    display: flex;
    flex-direction: column;
    width: ${({ isOrderType, isOrderStatus, isOrderNo, isOrderPrice }) =>
        isOrderType
            ? '40%'
            : isOrderStatus
            ? '60%'
            : isOrderNo
            ? '70%'
            : isOrderPrice && '30%'};
    align-items: ${({ isOrderType, isOrderStatus, isOrderNo, isOrderPrice }) =>
        isOrderType
            ? 'flex-start'
            : isOrderStatus
            ? 'flex-start'
            : isOrderNo
            ? 'flex-end'
            : isOrderPrice && 'flex-end'};

    ${media.smalDevice`
    width: ${({ isOrderType, isOrderStatus, isOrderNo, isOrderPrice }) =>
        isOrderType
            ? '40%'
            : isOrderStatus
            ? '60%'
            : isOrderNo
            ? '75%'
            : isOrderPrice && '25%'};
    `}

    ${media.mobileDevice`
    
    width: ${({ isOrderType, isOrderStatus, isOrderNo, isOrderPrice }) =>
        isOrderType
            ? '40%'
            : isOrderStatus
            ? '60%'
            : isOrderNo
            ? '70%'
            : isOrderPrice && '30%'};
    align-items: ${({ isOrderType, isOrderStatus, isOrderNo, isOrderPrice }) =>
        isOrderType
            ? 'flex-start'
            : isOrderStatus
            ? 'flex-end'
            : isOrderNo
            ? 'flex-start'
            : isOrderPrice && 'flex-end'}; 
                
    `}
`;

export const OrderNoTypeContainer = styled.div`
    width: 100%;
    display: flex;
    justify-content: flex-start;
    ${media.smalDevice`
        justify-content: flex-start;
    `}
    ${media.mobileDevice`
        justify-content: flex-start;
    `}
`;

export const OrderTypeFontStlye = styled.p`
    margin: 0;
    display: inline-block;
    opacity: 1;
    line-height: 24px;
    color: #140f4b;
    font-family: 'AvenirNextWorld Demi';
    text-transform: uppercase;
    font-size: 13.5px;
    letter-spacing: 0px;
    ${media.mobileDevice`
        font-size: 12.5px;
    `}
`;

export const InvoiceOrderPOFontStyle = styled.p`
    margin: 0;
    display: inline-block;
    font-family: 'AvenirNextWorld Regular';
    letter-spacing: 0px;
    color: #585858;
    opacity: ${({ isPoNumber, isOrderNo }) =>
        isPoNumber ? '0.7' : isOrderNo && '1'};
    font-size: ${({ isPoNumber, isOrderNo }) =>
        isPoNumber ? '12px' : isOrderNo && '13px'};
    line-height: ${({ isPoNumber, isOrderNo }) =>
        isPoNumber ? '21px' : isOrderNo && '20px'};

    ${({ isPoNumber }) =>
        isPoNumber &&
        css`
            &:before {
                // content: 'PO # ';
            }
        `}

    ${({ isOrderNo }) =>
        isOrderNo &&
        css`
            &:before {
                // content: 'Order # ';
                line-height: 22px;
                font-family: 'AvenirNextWorld Demi';
            }
        `}
`;

export const InvoiceStatusPrice = styled.p`
    margin: 0;
    display: inline-block;
    font-family: ${({ fontFamily, isInvoiceStatus, isPrice }) =>
        fontFamily
            ? fontFamily
            : isInvoiceStatus
            ? 'AvenirNextWorld Demi'
            : isPrice && 'AvenirNextWorld Bold'};
    letter-spacing: 0px;
    opacity: ${({ isInvoiceStatus, isPrice }) =>
        isInvoiceStatus ? '1' : isPrice && '0.9'};
    color: ${({ isInvoiceStatus, isPrice }) =>
        isInvoiceStatus ? '#585858' : isPrice && '#C529BB'};
    font-size: ${({ isInvoiceStatus, isPrice }) =>
        isInvoiceStatus ? '13px' : isPrice && '14px'};
    line-height: ${({ isInvoiceStatus, isPrice }) =>
        isInvoiceStatus ? '22px' : isPrice && '24px'};

    ${({ isPrice }) =>
        isPrice &&
        css`
            &:before {
                // content: '$';
                font-family: ${({ fontFamily }) =>
                    fontFamily ? fontFamily : 'AvenirNextWorld Bold'};
                font-size: 14px;
            }
        `};

    ${media.mobileDevice`
        font-size: ${({ isInvoiceStatus }) => isInvoiceStatus && '12px'};
    `}
`;

export const OrderTypeSpanContianer = styled.div`
    width: 25px;
    height: 20px;
    position: relative;
    margin-left: 3px;
    margin-right: 10px;
    opacity: 1;
    background: transparent url(${({ sourcePath }) => sourcePath}) 0% 0%
        no-repeat padding-box;
`;

export const OrderTypeSpan = styled.span`
    font-family: 'AvenirNextWorld Bold';
    opacity: 0.92;
    letter-spacing: 0px;
    line-height: 20px;
    font-size: 10px;
    color: ${({ isTissue, isNonTissue, isReplenish }) =>
        isTissue
            ? '#C27900'
            : isNonTissue
            ? '#6D6D6D'
            : isReplenish && '#416E10'};
`;

export const OrderCountContainer = styled.div`
    display: inline-block;
    position: absolute;
    width: 14px;
    height: 14px;
    border-radius: 8px;
    background-color: #c529bb;
    top: -5px;
    right: -7px;
`;

export const OrderCountSpan = styled.span`
    font-family: 'AvenirNextWorld Demi';
    font-size: 8px;
    color: #ffffff;
    text-align: center;
    text-align: center;
    position: absolute;
    width: 105%;
`;

export const InvoiceCreatedContainer = styled.div`
    width: 60%;
    order: 2;
    display: flex;
    justify-content: flex-end;
`;

export const InvoiceCreatedDetail = styled.p`
    margin: ${({ margin }) => (margin ? margin : '0 5px 0 0')};
    font-family: 'AvenirNextWorld Regular';
    font-size: 10px;
    line-height: 18px;
    letter-spacing: 0px;
    color: #202124;
    opacity: 1;
    ${media.mobileDevice`
        font-size: 9px;
    `}

    ${({ isCreatedDate }) =>
        isCreatedDate &&
        css`
            &:before,
            &:after {
                content: ' | ';
            }
        `}

    ${({ isCreatedDateBy }) =>
        isCreatedDateBy &&
        css`
            &:after {
                content: ' | ';
                opacity: 20%;
            }
        `}
`;

export const Notch = styled.div`
    position: absolute;
    background-color: #f9f9f9;
    height: 0px !important;
    width: 100% !important;
    top: -6px;

    :after {
        content: '';
        display: block;
        width: 8px;
        height: 8px;
        background: #f9f9f9;
        border-right: 1.1px solid #dedede;
        border-bottom: 1.1px solid #dedede;
        position: absolute;
        margin: auto;
        left: 0;
        right: 0;
        transform: rotate(-135deg);
        -webkit-transform: rotate(-135deg);
    }
`;
